
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diwalicheatsheet",
      function () {
        return require("private-next-pages/diwalicheatsheet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diwalicheatsheet"])
      });
    }
  